import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { createBrowserHistory } from 'history';
import isEmpty from 'lodash/isEmpty';
import { SnackbarProvider } from 'notistack';
import React, { lazy, Suspense, useEffect, useLayoutEffect } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import 'src/App.css';
import { IS_AUTH } from 'src/contents/Constants';
import actions from 'src/redux/actions';
import store from 'src/redux/store';
import RouteApp from 'src/routes';
import services from 'src/services';
import connectSocket from 'src/socket';
import theme from 'src/utils/theme';
import dispatch from 'src/utils/dispatch';
import { loadFbLoginApi } from 'src/utils/facebook';

const AddCartAnimation = lazy(() =>
  import('src/components/2.2.0/common/AddCartAnimation')
);
const AlertMessage = lazy(() => import('src/components/alert-message'));
const DepositDetailModalGlobal = lazy(() =>
  import('src/components/deposit/deposit-detail-global-modal')
);
const NotificationModal = lazy(() =>
  import('src/components/modals/NotificationModal')
);

export function getStore() {
  return store;
}

export const history = createBrowserHistory();

export default function App() {
  // useEffect(() => {
  //   const dunsIframe = document.querySelector(
  //     `script[src="https://dunsregistered.dnb.com/"]`
  //   );
  //   const dunsContainer = document.querySelector('iframe#Iframe1');
  //   dunsIframe.remove();
  //   dunsContainer.remove();

  //   const container = document.createElement('div');
  //   container.style = 'position: absolute;bottom: 0;z-index: -1;opacity:0;';
  //   container.appendChild(dunsIframe);
  //   container.appendChild(dunsContainer);
  //   document.body.appendChild(container);
  // });

  useLayoutEffect(() => {
    (async () => {
      try {
        const response = await services.getConfiguration();
        if (isEmpty(response)) {
          throw new Error('Vui lòng bổ sung theme configuration');
        }

        const { data } = response;
        dispatch(actions.setting({ ...data, theme }));
      } catch (error) {
        throw new Error(error);
      }
    })();
  }, []);

  useEffect(() => {
    const isAuth = Boolean(localStorage.getItem(IS_AUTH));
    if (isAuth) {
      dispatch(actions.getUserProfile());
    }
  }, []);

  useEffect(() => {
    connectSocket();
    loadFbLoginApi();
  }, []);

  return (
    <ThemeProvider theme={createTheme(theme)}>
      <CssBaseline />

      <Provider store={store}>
        <SnackbarProvider maxSnack={3}>
          <Router history={history}>
            <RouteApp />
          </Router>

          <Suspense fallback={<div />}>
            <AddCartAnimation />
          </Suspense>

          <Suspense fallback={<div />}>
            <AlertMessage />
          </Suspense>

          <Suspense fallback={<div />}>
            <NotificationModal />
          </Suspense>

          <Suspense fallback={<div />}>
            <DepositDetailModalGlobal />
          </Suspense>
        </SnackbarProvider>
      </Provider>
    </ThemeProvider>
  );
}
